import { isEmpty } from 'lodash'
import { gql } from '@apollo/client'

import { SEASON_TYPE } from 'features/SeasonEvents/components/SeasonType/constants'
import { FARE_TYPE } from 'features/FareFamilies/components/FareType/constants'
import { DEMAND } from 'features/FareFamilies/components/Demand/constants'
import { SERVICE_TYPE } from 'features/FareFamilies/components/ServiceType/constants'

const getBookingClassByTaxonomy = (taxonomy = '', bookingClasses = []): TSFixMe => {
  const bookingClassName = taxonomy[0]

  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  return bookingClasses.find((bookingClass): TSFixMe => bookingClass.isActive && bookingClass.name === bookingClassName)
}

const isValidFareTypeName = (fareTypeName: TSFixMe, bookingClass: TSFixMe): TSFixMe => {
  let validFares = [FARE_TYPE.NORMAL]

  if (bookingClass.promo) {
    validFares = [FARE_TYPE.NORMAL, FARE_TYPE.PROMO]
  }

  return validFares.indexOf(fareTypeName) > -1
}

const getFareTypeByTaxonomy = (taxonomy: TSFixMe, bookingClass: TSFixMe): TSFixMe => {
  if (bookingClass) {
    const fareTypeName = taxonomy[1]

    if (isValidFareTypeName(fareTypeName, bookingClass)) {
      return fareTypeName
    }
  }

  return ''
}

const getSeasonTypeByTaxonomy = (taxonomy: TSFixMe): TSFixMe => {
  const validSeasons = [SEASON_TYPE.L, SEASON_TYPE.S, SEASON_TYPE.H, SEASON_TYPE.E, SEASON_TYPE.N]

  const seasonTypeName = taxonomy[2]

  if (validSeasons.indexOf(seasonTypeName) > -1) {
    return seasonTypeName
  }

  return ''
}

const getTimeWindowByTaxonomy = (taxonomy: TSFixMe): TSFixMe => {
  const validTimeWindow = [0, 1, 2, 3, 4, 5, 6, 7]

  const timeWindow = parseInt(taxonomy[3])

  if (validTimeWindow.indexOf(timeWindow) > -1) {
    return timeWindow
  }

  return ''
}

const getDowByTaxonomy = (taxonomy: TSFixMe): TSFixMe => {
  const validDow = [0, 1, 2, 3, 4, 5, 6, 7]

  const dow = parseInt(taxonomy[4])

  if (validDow.indexOf(dow) > -1) {
    return dow
  }

  return ''
}

const getDemandByTaxonomy = (taxonomy: TSFixMe): TSFixMe => {
  const validDemand = [DEMAND.N, DEMAND.D, DEMAND.L, DEMAND.I, DEMAND.T]

  const demand = taxonomy[5]

  if (validDemand.indexOf(demand) > -1) {
    return demand
  }

  return ''
}

const getSalesChannelByTaxonomy = (taxonomy: TSFixMe): TSFixMe => {
  const validSalesChannel = [0, 1, 2]

  const salesChannel = parseInt(taxonomy[6])

  if (validSalesChannel.indexOf(salesChannel) > -1) {
    return salesChannel
  }

  return ''
}

const getServiceTypeByTaxonomy = (taxonomy: TSFixMe): TSFixMe => {
  const validServiceType = [SERVICE_TYPE.L, SERVICE_TYPE.P, SERVICE_TYPE.E]

  const serviceType = taxonomy[7]

  if (validServiceType.indexOf(serviceType) > -1) {
    return serviceType
  }

  return ''
}

export const getFareByTaxonomy = (taxonomy: TSFixMe, bookingClasses: TSFixMe): TSFixMe => {
  const bookingClass = getBookingClassByTaxonomy(taxonomy, bookingClasses)
  const fareType = getFareTypeByTaxonomy(taxonomy, bookingClass)
  const seasonType = getSeasonTypeByTaxonomy(taxonomy)
  const timeWindow = getTimeWindowByTaxonomy(taxonomy)
  const dow = getDowByTaxonomy(taxonomy)
  const demand = getDemandByTaxonomy(taxonomy)
  const salesChannel = getSalesChannelByTaxonomy(taxonomy)
  const serviceType = getServiceTypeByTaxonomy(taxonomy)

  return {
    taxonomy,
    bookingClass: bookingClass || { id: '', name: '' },
    type: fareType,
    seasonType,
    timeWindow,
    dow,
    demand,
    salesChannel,
    serviceType
  }
}

export const getTaxonomyByFare = (fare: TSFixMe, familyName: TSFixMe): TSFixMe => {
  return `${fare.bookingClass.name}\
${fare.type}\
${fare.seasonType}\
${fare.timeWindow}\
${fare.dow}\
${fare.demand}\
${fare.salesChannel}\
${fare.serviceType}\
${familyName}`
}

export const getDefaultFare = (fares = []): TSFixMe => {
  let defaultFare: TSFixMe

  fares.forEach((fare): TSFixMe => {
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    if (fare.isActive) {
      if (isEmpty(defaultFare)) {
        defaultFare = fare
      }

      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      if (fare.basePrice < defaultFare.basePrice) {
        defaultFare = fare
      }
    }
  })

  return defaultFare
}

export const resolvers = {
  Mutation: {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    updateFamilyFare(_root: TSFixMe, { fareFamily }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'FareFamily',
          id: fareFamily.id
        }),
        fragment: gql`
          fragment FareFamilyFares on FareFamily {
            fares {
              id
              bookingClass {
                id
                name
              }
              seasonType
              serviceType
              type
              timeWindow
              dow
              demand
              salesChannel
              basePrice
              isActive
              createdAt
              updatedAt
            }
          }
        `,
        data: {
          fares: fareFamily.fares,
          __typename: 'FareFamily'
        }
      })

      return null
    }
  },
  FareFamily: {
    defaultFare({ fares = [] }): TSFixMe {
      return getDefaultFare(fares)
    }
  }
}
